import React, { useEffect } from "react";
import styled from "styled-components";
import Card from "./Card"
import html from "./Images/html&css.png"
import js from "./Images/js.png"
import react from "./Images/reactjs.png"
import redux from "./Images/react-redux.png"
import github from "./Images/github.png"
import mongoose from "./Images/mongoose.png"
import nodejs from "./Images/nodejs.png"
import expressjs from "./Images/expressjs2.jpg"
import AOS from "aos";
import "aos/dist/aos.css";

const Tool = () =>{

    useEffect(() => {
        AOS.init({duration: 2000})
    }, []);


    return(
        <Container>
            <H1>SOFT SKILL</H1>
            <Wrapper>
                <Card  image={html} description="HTML and CSS are the beginning of everything you need to know to make your first web page! Learn both and start creating amazing websites."  title="Html & Css"/>
                <Card data-aos="zoom-in" image={js} description="JavaScript is an object oriented programming language, meaning that you can write very detailed instructions (and algorithms) in it." title="Javascript"/>
                <Card  data-aos="zoom-in" image={react}  title="React Js" description="React is a JavaScript library for building user interfaces. React is used to build single-page applications. React allows us to create reusable UI components."/>
                {/* <Card image={native} title="React Native" description="React Native is an open-source JavaScript framework, designed for building apps on multiple platforms like iOS, Android, and also web applications, utilizing the very same code base. It is based on React, and it brings all its glory to mobile app development."/> */}
                <Card data-aos="zoom-in" image={redux} description="Redux is a predictable state container designed to help you write JavaScript apps that behave consistently across client, server, and native environments. While it's mostly used as a state management tool with React, it can be used with any other JavaScript framework or library." title="Redux"/>
                <Card data-aos="zoom-out" image={github} title="Github" description="GitHub is an online software development platform. It's used for storing, tracking, and collaborating on software projects. It makes it easy for developers to share code files and collaborate with fellow developers on open-source projects."/>
                <Card data-aos="zoom-out" image={nodejs} title="Node Js" description="Node.js is a cross-platform, open-source server environment that can run on Windows, Linux, Unix, macOS, and more. Node.js is a back-end JavaScript runtime environment, runs on the V8 JavaScript engine, and executes JavaScript code outside a web browser."/>
                <Card data-aos="zoom-out" image={mongoose} title="MongoDB" description="MongoDB is a source-available cross-platform document-oriented database program. Classified as a NoSQL database program, MongoDB uses JSON-like documents with optional schemas."/>
                <Card data-aos="zoom-out" image={expressjs} title="Express" description="Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.
"/>
            </Wrapper>
        </Container>
    )
};

export default Tool;
const H1 = styled.h1`
font-size: 40px;
color:#2b2c2c;

`;

const Container = styled.div`
width: 100%;
height: auto;
background-color: white;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding: 60px 0;
`;
const Wrapper = styled.div`
width: 90%;
height: 90%;
display: flex;
justify-content: space-between;
flex-wrap: wrap;


@media Screen and (max-width: 768px){
    flex-wrap: wrap;
    justify-content: center;
}
`;

